import React, { useEffect } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import moment from "moment";
import { Box, Grid, InputAdornment, Stack, TextField } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { useDispatch, useSelector } from "react-redux";
import { createProductOfferThunk } from "store/reducers/product/productOffersSlice";

const validation = yup.object({
  name: yup.string("Enter name").required("Name required"),
  desc: yup.string("Enter desc"),
  offer_percentage: yup
    .number("Enter offer")
    .required("Offer required")
    .positive()
    .min(1),
  offer_to_date: yup
    .string("Enter offer to date")
    .required("Offer to date required"),
  offer_from_date: yup
    .string("Enter offer from date")
    .required("Offer from date required"),
});
const ProductOfferForm = ({ product_id, offer, fullGrid = false }) => {
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      name: offer?.name ?? "",
      desc: offer?.desc ?? "",
      offer_percentage: offer?.offer_percentage ?? 10,
      offer_from_date: offer?.offer_to_date ?? moment().format("YYYY-MM-DD"),
      offer_to_date:
        offer?.offer_from_date ?? moment().add(7, "days").format("YYYY-MM-DD"),
    },
    validationSchema: validation,

    onSubmit: (data) => {
      console.log(data);
      dispatch(createProductOfferThunk({ ...data, product: product_id }));
    },
    validateOnChange: false,
  });

  const { loading } = useSelector((state) => state.productOffer);

  return (
    <Box marginTop={2}>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={1.5} paddingY={1}>
          <Grid item xs={12} md={fullGrid ? 12 : 6} lg={fullGrid ? 12 : 4}>
            <Stack spacing={2}>
              <TextField
                label="Name"
                variant="outlined"
                name="name"
                fullWidth
                value={formik.values.name}
                onChange={formik.handleChange}
                error={Boolean(formik.errors.name)}
                helperText={formik.errors.name}
                autoComplete="new-password"
                type="text"
                required
              />
              <TextField
                label="Desc"
                variant="outlined"
                name="desc"
                fullWidth
                value={formik.values.desc}
                onChange={formik.handleChange}
                error={Boolean(formik.errors.desc)}
                helperText={formik.errors.desc}
                autoComplete="new-password"
                type="text"
                multiline
                maxRows={4}
              />
              <TextField
                label="Offer percentage"
                variant="outlined"
                name="offer_percentage"
                fullWidth
                value={formik.values.offer_percentage}
                onChange={formik.handleChange}
                error={Boolean(formik.errors.offer_percentage)}
                helperText={formik.errors.offer_percentage}
                autoComplete="new-password"
                type="text"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">%</InputAdornment>
                  ),
                }}
              />
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DesktopDatePicker
                  label="Offer from date"
                  inputFormat="YYYY-MM-DD"
                  name="offer_from_date"
                  value={formik.values.offer_from_date}
                  onChange={(value) =>
                    formik.setFieldValue("offer_from_date", value.format("YYYY-MM-DD"), true)
                  }
                  renderInput={(params) => (
                    <TextField fullWidth variant="outlined" {...params} />
                  )}
                />
              </LocalizationProvider>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DesktopDatePicker
                  label="Offer to date"
                  inputFormat="YYYY-MM-DD"
                  name="offer_to_date"
                  value={formik.values.offer_to_date}
                  onChange={(value) =>
                    formik.setFieldValue("offer_to_date", value.format("YYYY-MM-DD"), true)
                  }
                  renderInput={(params) => (
                    <TextField fullWidth variant="outlined" {...params} />
                  )}
                />
              </LocalizationProvider>
            </Stack>
          </Grid>
        </Grid>

        <LoadingButton
          variant="contained"
          type="submit"
          sx={{ paddingX: 10, marginTop: 1 }}
          loading={loading?.create === product_id}
        >
          Add
        </LoadingButton>
      </form>
    </Box>
  );
};

export default ProductOfferForm;
